/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetMarketMakerMetricsOptions,
  GetMarketMakerMetricsResponses,
} from '../types/GetMarketMakerMetrics'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admins and the market maker's own user. Buckets are UTC-aligned. Without order_book_id the points cover the assigned books; each book is queried on its own and its range may cover at most 3 days of minutes, 90 days of hours or 400 days of days. Depth values are the minimum observed in the bucket, while the KPI report averages each minute's minimum over the window, so a day here can read lower than /kpis?window=day. avg_spread is weighted by two-sided seconds; volumes are sums.
 * @summary Market maker measurements as a time series
 * {@link /v1/market-makers/:market_maker_id/metrics}
 */
export function getMarketMakerMetrics<ThrowOnError extends boolean = true>(
  options: Options<GetMarketMakerMetricsOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetMarketMakerMetricsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/market-makers/{market_maker_id}/metrics',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetMarketMakerMetricsResponses, ThrowOnError>>,
  )
}
